(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbs-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-nbs-reveal-root]');
    if (!roots.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    roots.forEach((root) => {
      const items = root.querySelectorAll('.nbs-reveal');
      if (reduced || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.2 });
      items.forEach((item, index) => {
        item.style.transitionDelay = `${Math.min(index % 4, 3) * 60}ms`;
        observer.observe(item);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbs-product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-nbs-product-root]').forEach((root) => {
      root.querySelectorAll('[data-nbs-gallery]').forEach((gallery) => {
        gallery.querySelectorAll('[data-nbs-media-target]').forEach((button) => {
          button.addEventListener('click', () => {
            gallery.querySelectorAll('.nbs-gallery__slide,.nbs-gallery__thumb').forEach((item) => item.classList.remove('is-active'));
            gallery.querySelector(`[data-media-id="${button.dataset.nbsMediaTarget}"]`)?.classList.add('is-active');
            button.classList.add('is-active');
          });
        });
      });
      const quantity = root.querySelector('input[name="quantity"]');
      root.querySelector('[data-nbs-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
      root.querySelector('[data-nbs-quantity-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });
      const mainButton = root.querySelector('[ref="addToCartButton"]');
      const sticky = root.querySelector('[data-nbs-sticky-atc]');
      if (mainButton && sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
        observer.observe(mainButton);
        sticky.querySelector('[data-nbs-sticky-submit]')?.addEventListener('click', () => mainButton.click());
      }
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveals = root.querySelectorAll('.nbs-reveal');
      if (reduced || !('IntersectionObserver' in window)) reveals.forEach((item) => item.classList.add('is-visible'));
      else {
        const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } }), { threshold: .2 });
        reveals.forEach((item) => revealObserver.observe(item));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
